import classNames from 'classnames';

import styles from './_index.module.scss';

const Page = ({ children, className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <div className={classNames(styles['page'], className)} {...props}>
      {children}
    </div>
  );
};

export default Page;
